<template>
  <div>
    <l-alert v-bind="$attrs" :message="a.message" :title="a.title" :type="a.type" v-model="globalAlertActivate"></l-alert>
    <!--全局操作确认-->
    <l-operation-dialog
      :cancelText="o.cancelText"
      :confirmText="o.confirmText"
      :disableCancel="o.disableCancel"
      :disableConfirm="o.disableConfirm"
      :icon="o.icon"
      :iconColor="o.iconColor"
      :onCancel="o.onCancel"
      :onConfirm="o.onConfirm"
      :subText="o.subText"
      :text="o.text"
      :title="o.title"
      :width="o.width"
      v-model="globalOperationActivate"
    ></l-operation-dialog>
  </div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields'
const {mapFields} = createHelpers({
  getterType: '$L/getField',
  mutationType: '$L/updateField',
})
export default {
  name: 'LGlobal',
  computed: {
    ...mapFields([
      'globalAlert',
      'globalAlertActivate',
      'globalOperation',
      'globalOperationActivate',
    ]),
    a () {
      return this.globalAlert
    },
    o () {
      return this.globalOperation
    },
  },
}
</script>

<style scoped>

</style>
